/* VERA GRANDE — global.js */
(function () {
  'use strict';

  var VG = window.VG || {};
  var $ = function (sel, ctx) { return (ctx || document).querySelector(sel); };
  var $$ = function (sel, ctx) { return Array.prototype.slice.call((ctx || document).querySelectorAll(sel)); };

  /* ---------- Helpers ---------- */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') cents = cents.replace('.', '');
    format = format || VG.moneyFormat || '${{amount}}';
    var placeholder = /\{\{\s*(\w+)\s*\}\}/;
    function withDelimiters(number, precision, thousands, decimal) {
      precision = precision == null ? 2 : precision;
      thousands = thousands || ',';
      decimal = decimal || '.';
      if (isNaN(number) || number == null) return 0;
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.');
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var c = parts[1] ? decimal + parts[1] : '';
      return dollars + c;
    }
    var match = format.match(placeholder);
    var value = '';
    switch (match ? match[1] : 'amount') {
      case 'amount': value = withDelimiters(cents, 2); break;
      case 'amount_no_decimals': value = withDelimiters(cents, 0); break;
      case 'amount_with_comma_separator': value = withDelimiters(cents, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': value = withDelimiters(cents, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': value = withDelimiters(cents, 2, "'", '.'); break;
      default: value = withDelimiters(cents, 2);
    }
    return format.replace(placeholder, value);
  }
  VG.formatMoney = formatMoney;

  function toast(msg) {
    var t = $('#VgToast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('is-visible');
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.classList.remove('is-visible'); }, 2800);
  }
  VG.toast = toast;

  function debounce(fn, wait) {
    var t;
    return function () {
      var args = arguments, ctx = this;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, wait);
    };
  }

  /* ---------- Drawers ---------- */
  var lastFocus = null;
  function openDrawer(el) {
    if (!el) return;
    lastFocus = document.activeElement;
    el.classList.add('is-open');
    el.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    var focusable = $('button, a, input', el);
    if (focusable) setTimeout(function () { focusable.focus(); }, 350);
  }
  function closeDrawer(el) {
    if (!el) return;
    el.classList.remove('is-open');
    el.setAttribute('aria-hidden', 'true');
    if (!$('.drawer.is-open, .search-overlay.is-open')) document.body.classList.remove('no-scroll');
    if (lastFocus) lastFocus.focus();
  }
  VG.openDrawer = openDrawer;
  VG.closeDrawer = closeDrawer;

  document.addEventListener('click', function (e) {
    var opener = e.target.closest('[data-drawer-open]');
    if (opener) {
      var target = document.getElementById(opener.getAttribute('data-drawer-open'));
      if (target) {
        if (opener.getAttribute('data-drawer-open') === 'CartDrawer' && VG.cartType !== 'drawer') return;
        e.preventDefault();
        openDrawer(target);
      }
      return;
    }
    var closer = e.target.closest('[data-drawer-close]');
    if (closer) {
      e.preventDefault();
      closeDrawer(closer.closest('.drawer'));
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    $$('.drawer.is-open').forEach(closeDrawer);
    closeSearch();
    $$('.modal.is-open, .lightbox.is-open').forEach(function (m) { m.classList.remove('is-open'); });
    document.body.classList.remove('no-scroll');
  });

  /* ---------- Header ---------- */
  function initHeader() {
    var wrapper = $('.header-wrapper');
    var header = $('.header');
    if (!header || !wrapper) return;
    var sectionEl = wrapper.closest('.shopify-section') || wrapper.parentElement;
    var floating = wrapper.classList.contains('header-wrapper--transparent') && wrapper.classList.contains('is-sticky');
    var onScroll = function () {
      var y = window.scrollY;
      header.classList.toggle('is-scrolled', y > 40);
      if (floating) {
        var ann = $('.announcement');
        var limit = ann ? ann.offsetHeight : 0;
        sectionEl.classList.toggle('is-fixed', y > limit);
      }
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- Announcement ---------- */
  function initAnnouncement(ctx) {
    $$('[data-announcement]', ctx).forEach(function (bar) {
      var items = $$('.announcement__item', bar);
      if (items.length < 2) return;
      var i = 0;
      var speed = parseInt(bar.getAttribute('data-speed'), 10) || 5000;
      clearInterval(bar._timer);
      bar._timer = setInterval(function () {
        items[i].classList.remove('is-active');
        i = (i + 1) % items.length;
        items[i].classList.add('is-active');
      }, speed);
    });
  }

  /* ---------- Hero slideshow ---------- */
  function initHero(ctx) {
    $$('[data-hero]', ctx).forEach(function (hero) {
      var slides = $$('.hero__slide', hero);
      var dots = $$('.hero__dot', hero);
      if (slides.length < 2) return;
      var current = 0;
      var autoplay = hero.getAttribute('data-autoplay') === 'true';
      var speed = (parseInt(hero.getAttribute('data-speed'), 10) || 6) * 1000;
      function go(n) {
        slides[current].classList.remove('is-active');
        if (dots[current]) dots[current].classList.remove('is-active');
        current = (n + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        if (dots[current]) {
          dots[current].classList.remove('is-active');
          void dots[current].offsetWidth;
          dots[current].classList.add('is-active');
        }
        restart();
      }
      function restart() {
        clearInterval(hero._timer);
        if (autoplay) hero._timer = setInterval(function () { go(current + 1); }, speed);
      }
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); }); });
      var prev = $('.hero__prev', hero), next = $('.hero__next', hero);
      if (prev) prev.addEventListener('click', function () { go(current - 1); });
      if (next) next.addEventListener('click', function () { go(current + 1); });
      var startX = null;
      hero.addEventListener('touchstart', function (e) { startX = e.touches[0].clientX; }, { passive: true });
      hero.addEventListener('touchend', function (e) {
        if (startX === null) return;
        var dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) go(current + (dx < 0 ? 1 : -1));
        startX = null;
      });
      restart();
      hero._go = go;
    });
  }

  /* ---------- Sliders ---------- */
  function initSliders(ctx) {
    $$('[data-slider-wrap]', ctx).forEach(function (wrap) {
      if (!$('.slider', wrap)) return;
      var visible = function () { return $$('.slider', wrap).filter(function (s) { return s.offsetParent !== null; })[0]; };
      $$('[data-slider-prev]', wrap).forEach(function (b) {
        b.addEventListener('click', function () { var t = visible(); if (t) t.scrollBy({ left: -t.clientWidth * 0.8 }); });
      });
      $$('[data-slider-next]', wrap).forEach(function (b) {
        b.addEventListener('click', function () { var t = visible(); if (t) t.scrollBy({ left: t.clientWidth * 0.8 }); });
      });
    });
  }

  /* ---------- Tabs ---------- */
  function initTabs(ctx) {
    $$('[data-tabs]', ctx).forEach(function (tabs) {
      var btns = $$('[data-tab]', tabs);
      btns.forEach(function (btn) {
        btn.addEventListener('click', function () {
          btns.forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-selected', 'false'); });
          btn.classList.add('is-active');
          btn.setAttribute('aria-selected', 'true');
          $$('.tab-panel', tabs).forEach(function (p) { p.hidden = p.id !== btn.getAttribute('data-tab'); });
        });
      });
    });
  }

  /* ---------- Testimonials ---------- */
  function initTestimonials(ctx) {
    $$('[data-testimonials]', ctx).forEach(function (wrap) {
      var items = $$('.testimonial', wrap);
      var dots = $$('.testimonials__dots button', wrap);
      if (items.length < 2) return;
      var i = 0;
      function go(n) {
        items[i].classList.remove('is-active'); dots[i] && dots[i].classList.remove('is-active');
        i = (n + items.length) % items.length;
        items[i].classList.add('is-active'); dots[i] && dots[i].classList.add('is-active');
      }
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); restart(); }); });
      function restart() { clearInterval(wrap._timer); wrap._timer = setInterval(function () { go(i + 1); }, 7000); }
      restart();
    });
  }

  /* ---------- Countdown ---------- */
  function initCountdown(ctx) {
    $$('[data-countdown]', ctx).forEach(function (el) {
      var end = new Date(el.getAttribute('data-countdown')).getTime();
      if (isNaN(end)) return;
      var f = function (n) { return n < 10 ? '0' + n : n; };
      function tick() {
        var diff = Math.max(0, end - Date.now());
        var d = Math.floor(diff / 864e5), h = Math.floor(diff / 36e5) % 24, m = Math.floor(diff / 6e4) % 60, s = Math.floor(diff / 1e3) % 60;
        var set = function (k, v) { var n = $('[data-' + k + ']', el); if (n) n.textContent = f(v); };
        set('days', d); set('hours', h); set('minutes', m); set('seconds', s);
      }
      tick();
      clearInterval(el._timer);
      el._timer = setInterval(tick, 1000);
    });
  }

  /* ---------- Video ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-video-play]');
    if (!btn) return;
    var wrap = btn.closest('[data-video]');
    var tpl = $('template', wrap);
    if (tpl) {
      var media = $('.media', wrap);
      media.innerHTML = '';
      media.appendChild(tpl.content.cloneNode(true));
      var v = $('video', media); if (v) v.play();
    }
  });

  /* ---------- Reveal on scroll ---------- */
  function initReveal(ctx) {
    var els = $$('.reveal:not(.is-visible)', ctx);
    if (!('IntersectionObserver' in window) || !document.body.classList.contains('has-animations')) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el, i) {
      el.style.transitionDelay = ((i % 4) * 90) + 'ms';
      io.observe(el);
    });
  }

  /* ---------- Quantity buttons ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-btn]');
    if (!btn) return;
    var input = $('input', btn.closest('.qty'));
    var val = parseInt(input.value, 10) || 0;
    var min = parseInt(input.min, 10) || 0;
    input.value = Math.max(min, btn.getAttribute('data-qty-btn') === 'plus' ? val + 1 : val - 1);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Cart ---------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? count : '';
      el.setAttribute('data-count', count);
    });
  }

  function refreshCartDrawer(open) {
    return fetch(VG.routes.root + '?sections=cart-drawer')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        var drawer = $('#CartDrawer');
        if (html && drawer) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = $('#CartDrawer', doc);
          if (fresh) drawer.innerHTML = fresh.innerHTML;
        }
        return fetch(VG.routes.cart + '.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        updateCartCount(cart.item_count);
        if (open) openDrawer($('#CartDrawer'));
        return cart;
      });
  }
  VG.refreshCart = refreshCartDrawer;

  function addToCart(form, btn) {
    btn && btn.classList.add('is-loading');
    var fd = new FormData(form);
    return fetch(VG.routes.cart_add + '.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: fd
    })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.data.description || res.data.message || VG.strings.error);
        if (VG.cartType === 'drawer' && $('#CartDrawer')) return refreshCartDrawer(true);
        window.location.href = VG.routes.cart;
      })
      .catch(function (err) { toast(err.message); })
      .finally(function () { btn && btn.classList.remove('is-loading'); });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target.closest('form[data-ajax-cart]');
    if (!form) return;
    if (VG.cartType !== 'drawer') return;
    e.preventDefault();
    addToCart(form, $('[type="submit"]', form));
  });

  function changeLine(line, qty) {
    var body = $('#CartDrawer .drawer__body');
    if (body) body.classList.add('is-loading');
    return fetch(VG.routes.cart_change + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        if (cart.status && cart.description) toast(cart.description);
        return refreshCartDrawer(false);
      })
      .catch(function () { toast(VG.strings.error); });
  }

  document.addEventListener('change', function (e) {
    var input = e.target.closest('#CartDrawer [data-line-qty]');
    if (input) changeLine(parseInt(input.getAttribute('data-line-qty'), 10), parseInt(input.value, 10) || 0);
    var note = e.target.closest('#CartDrawer [name="note"]');
    if (note) {
      fetch(VG.routes.cart_update + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }
  });

  document.addEventListener('click', function (e) {
    var rm = e.target.closest('#CartDrawer [data-line-remove]');
    if (!rm) return;
    e.preventDefault();
    changeLine(parseInt(rm.getAttribute('data-line-remove'), 10), 0);
  });

  /* ---------- Search overlay ---------- */
  function openSearch() {
    var o = $('#SearchOverlay');
    if (!o) return;
    o.classList.add('is-open');
    document.body.classList.add('no-scroll');
    setTimeout(function () { var i = $('input[type="search"]', o); i && i.focus(); }, 300);
  }
  function closeSearch() {
    var o = $('#SearchOverlay');
    if (!o || !o.classList.contains('is-open')) return;
    o.classList.remove('is-open');
    if (!$('.drawer.is-open')) document.body.classList.remove('no-scroll');
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-search-open]')) { e.preventDefault(); openSearch(); }
    if (e.target.closest('[data-search-close]')) { e.preventDefault(); closeSearch(); }
  });

  function initPredictive() {
    var o = $('#SearchOverlay');
    if (!o || o.getAttribute('data-predictive') !== 'true') return;
    var input = $('input[type="search"]', o);
    var results = $('[data-predictive-results]', o);
    input.addEventListener('input', debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { results.innerHTML = ''; return; }
      fetch(VG.routes.predictive_search + '?q=' + encodeURIComponent(q) + '&section_id=predictive-search&resources[limit]=6')
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = $('[data-predictive-inner]', doc);
          results.innerHTML = inner ? inner.innerHTML : '';
        })
        .catch(function () {});
    }, 280));
  }

  /* ---------- Product ---------- */
  function initProduct(ctx) {
    $$('[data-product]', ctx).forEach(function (root) {
      var dataEl = $('[data-product-json]', root);
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var form = $('form[data-product-form]', root);
      var idInput = form ? $('input[name="id"]', form) : null;
      var atc = form ? $('[data-atc]', form) : null;
      var atcText = atc ? $('[data-atc-text]', atc) : null;
      var priceWrap = $('[data-price]', root);
      var inventory = $('[data-inventory]', root);
      var skuEl = $('[data-sku]', root);
      var stickyAtc = $('[data-sticky-atc]');
      var updateUrl = root.getAttribute('data-update-url') !== 'false';

      // Gallery
      var slides = $$('.product__slide', root);
      var thumbs = $$('.product__thumb', root);
      var current = 0;
      function showSlide(n) {
        if (!slides.length) return;
        n = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) { s.classList.toggle('is-active', i === n); });
        thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === n); });
        current = n;
      }
      thumbs.forEach(function (t, i) { t.addEventListener('click', function () { showSlide(i); }); });
      var prev = $('[data-gallery-prev]', root), next = $('[data-gallery-next]', root);
      if (prev) prev.addEventListener('click', function () { showSlide(current - 1); });
      if (next) next.addEventListener('click', function () { showSlide(current + 1); });
      var main = $('.product__main', root);
      if (main) {
        var sx = null;
        main.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (sx === null) return;
          var dx = e.changedTouches[0].clientX - sx;
          if (Math.abs(dx) > 40) showSlide(current + (dx < 0 ? 1 : -1));
          sx = null;
        });
      }

      // Lightbox
      var lightbox = $('[data-lightbox]', root);
      $$('[data-zoom]', root).forEach(function (m) {
        m.addEventListener('click', function () {
          if (!lightbox) return;
          $('img', lightbox).src = m.getAttribute('data-zoom');
          lightbox.classList.add('is-open');
        });
      });
      if (lightbox) lightbox.addEventListener('click', function () { lightbox.classList.remove('is-open'); });

      // Variant selection
      function selectedOptions() {
        return $$('[data-option-index]', root).map(function (fs) {
          var checked = $('input:checked', fs);
          var sel = $('select', fs);
          return checked ? checked.value : (sel ? sel.value : null);
        });
      }
      function findVariant(opts) {
        return variants.find(function (v) {
          return v.options.every(function (o, i) { return o === opts[i]; });
        });
      }
      function updateAvailability(opts) {
        $$('[data-option-index]', root).forEach(function (fs) {
          var idx = parseInt(fs.getAttribute('data-option-index'), 10);
          $$('input', fs).forEach(function (input) {
            var test = opts.slice(); test[idx] = input.value;
            var match = variants.find(function (v) {
              return v.options.every(function (o, i) { return i === idx ? o === input.value : (i < idx ? o === opts[i] : true); }) && v.available;
            });
            input.classList.toggle('is-unavailable', !match);
          });
          var label = $('[data-option-selected]', fs);
          if (label) label.textContent = opts[idx];
        });
      }
      function onChange() {
        var opts = selectedOptions();
        var v = findVariant(opts);
        updateAvailability(opts);
        if (!v) {
          if (atc) { atc.disabled = true; atcText.textContent = VG.strings.unavailable; }
          return;
        }
        if (idInput) { idInput.value = v.id; idInput.dispatchEvent(new Event('change', { bubbles: true })); }
        if (atc) {
          atc.disabled = !v.available;
          atcText.textContent = v.available ? VG.strings.addToCart : VG.strings.soldOut;
        }
        if (priceWrap) {
          var onSale = v.compare_at_price && v.compare_at_price > v.price;
          priceWrap.innerHTML = '<span class="price' + (onSale ? ' price--sale' : '') + '"><span class="price__current">' + formatMoney(v.price) + '</span>' +
            (onSale ? '<span class="price__compare">' + formatMoney(v.compare_at_price) + '</span>' : '') + '</span>';
        }
        if (skuEl) skuEl.textContent = v.sku || '';
        if (inventory) {
          var qty = v.inventory_quantity;
          var threshold = parseInt(inventory.getAttribute('data-threshold'), 10) || 5;
          inventory.className = 'product__inventory';
          if (!v.available) { inventory.classList.add('product__inventory--out'); inventory.textContent = inventory.getAttribute('data-out'); }
          else if (v.inventory_management && qty > 0 && qty <= threshold) {
            inventory.classList.add('product__inventory--low');
            inventory.textContent = inventory.getAttribute('data-low').replace('[count]', qty);
          } else { inventory.textContent = inventory.getAttribute('data-in'); }
        }
        if (v.featured_media) {
          var idx = slides.findIndex(function (s) { return s.getAttribute('data-media-id') == v.featured_media.id; });
          if (idx > -1) showSlide(idx);
        }
        if (stickyAtc) {
          var sp = $('[data-sticky-price]', stickyAtc); if (sp) sp.textContent = formatMoney(v.price);
          var sb = $('[data-sticky-btn]', stickyAtc); if (sb) sb.disabled = !v.available;
        }
        if (updateUrl && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      $$('[data-option-index] input, [data-option-index] select', root).forEach(function (el) {
        el.addEventListener('change', onChange);
      });
      if (variants.length) updateAvailability(selectedOptions());

      // Sticky ATC
      if (stickyAtc && atc && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          stickyAtc.classList.toggle('is-visible', !en[0].isIntersecting && en[0].boundingClientRect.top < 0);
        }).observe(atc);
        var sb = $('[data-sticky-btn]', stickyAtc);
        if (sb) sb.addEventListener('click', function () { atc.click(); });
      }
    });
  }

  /* ---------- Modals ---------- */
  document.addEventListener('click', function (e) {
    var op = e.target.closest('[data-modal-open]');
    if (op) {
      e.preventDefault();
      var m = document.getElementById(op.getAttribute('data-modal-open'));
      if (m) { m.classList.add('is-open'); document.body.classList.add('no-scroll'); }
      return;
    }
    var cl = e.target.closest('[data-modal-close]');
    if (cl) {
      e.preventDefault();
      cl.closest('.modal').classList.remove('is-open');
      document.body.classList.remove('no-scroll');
    }
  });

  /* ---------- Collection filters ---------- */
  function initFilters(ctx) {
    $$('form[data-filter-form]', ctx).forEach(function (form) {
      form.addEventListener('change', debounce(function (e) {
        if (e.target.matches('input[type="number"]')) return;
        submitFilters(form);
      }, 300));
      $$('input[type="number"]', form).forEach(function (n) {
        n.addEventListener('change', debounce(function () { submitFilters(form); }, 700));
      });
    });
    $$('[data-sort-select]', ctx).forEach(function (sel) {
      sel.addEventListener('change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', sel.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }
  function submitFilters(form) {
    var params = new URLSearchParams(new FormData(form));
    var sort = new URL(window.location.href).searchParams.get('sort_by');
    if (sort) params.set('sort_by', sort);
    Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
    window.location.href = window.location.pathname + '?' + params.toString();
  }

  /* ---------- Localization ---------- */
  document.addEventListener('change', function (e) {
    var sel = e.target.closest('[data-localization-select]');
    if (sel) sel.form.submit();
  });

  /* ---------- Monogram (initials) with live preview ---------- */
  function initMonogram(ctx) {
    $$('[data-monogram]', ctx).forEach(function (box) {
      var root = box.closest('[data-product]') || document;
      var toggle = $('[data-monogram-toggle]', box);
      var panel = $('[data-monogram-panel]', box);
      var input = $('[data-monogram-input]', box);
      var previewText = $('[data-monogram-preview-text]', box);
      var foilName = $('[data-monogram-foil-name]', box);
      var overlay = $('[data-monogram-overlay]', root);
      var overlayText = overlay ? $('[data-monogram-text]', overlay) : null;
      var fields = $$('input[name^="properties["]', box);
      var max = parseInt(box.getAttribute('data-max'), 10) || 3;
      var sample = previewText ? previewText.textContent : 'ABC';

      function formatted() {
        var raw = (input.value || '').toUpperCase().replace(/[^A-Z0-9&]/g, '').slice(0, max);
        var dots = $('[data-monogram-format]:checked', box);
        if (dots && dots.value === 'dots' && raw) raw = raw.split('').join('.') + '.';
        return raw;
      }
      function foil() {
        var f = $('[data-monogram-foil]:checked', box);
        return f ? f.getAttribute('data-monogram-foil') : 'gold';
      }
      function firstSlideActive() {
        var slides = $$('.product__slide', root);
        return !slides.length || slides[0].classList.contains('is-active') || root.querySelector('.product__gallery--grid');
      }
      function update() {
        var on = toggle.checked;
        var text = formatted();
        var cls = 'foil foil--' + foil();
        if (previewText) { previewText.textContent = text || sample; previewText.className = cls + ' monogram__initials' + (text ? '' : ' is-sample'); }
        var f = $('[data-monogram-foil]:checked', box);
        if (foilName && f) foilName.textContent = f.value;
        if (overlay && overlayText) {
          overlayText.textContent = text;
          overlayText.className = cls;
          overlay.hidden = !(on && text && firstSlideActive());
        }
        // send the formatted initials with the order
        input.dataset.formatted = text;
      }
      toggle.addEventListener('change', function () {
        panel.hidden = !toggle.checked;
        fields.forEach(function (el) { el.disabled = !toggle.checked; });
        input.required = toggle.checked;
        if (toggle.checked) {
          var first = $('.product__thumb', root); if (first) first.click();
          setTimeout(function () { input.focus(); }, 50);
        }
        update();
      });
      input.addEventListener('input', function () {
        var pos = input.selectionStart;
        input.value = input.value.toUpperCase().replace(/[^A-Z0-9&]/gi, '').slice(0, max);
        try { input.setSelectionRange(pos, pos); } catch (e) {}
        update();
      });
      $$('[data-monogram-foil], [data-monogram-format]', box).forEach(function (r) { r.addEventListener('change', update); });
      root.addEventListener('click', function (e) {
        if (e.target.closest('.product__thumb, [data-gallery-prev], [data-gallery-next]')) setTimeout(update, 0);
      });
      // put dotted format into the order property just before submit
      var form = input.form;
      if (form) form.addEventListener('submit', function () {
        if (toggle.checked && input.dataset.formatted) input.value = input.dataset.formatted;
      }, true);
      update();
    });
  }

  /* ---------- Product recommendations ---------- */
  function initRecommendations(ctx) {
    $$('[data-recommendations]', ctx).forEach(function (el) {
      if (el._loaded) return;
      el._loaded = true;
      fetch(el.getAttribute('data-url'))
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var inner = $('[data-recommendations-inner]', doc);
          if (inner && inner.innerHTML.trim()) {
            $('[data-recommendations-inner]', el).innerHTML = inner.innerHTML;
            initReveal(el);
          }
        })
        .catch(function () {});
    });
  }

  /* ---------- Init ---------- */
  function init(ctx) {
    initAnnouncement(ctx);
    initHero(ctx);
    initSliders(ctx);
    initTabs(ctx);
    initTestimonials(ctx);
    initCountdown(ctx);
    initProduct(ctx);
    initMonogram(ctx);
    initFilters(ctx);
    initRecommendations(ctx);
    initReveal(ctx);
  }

  document.addEventListener('DOMContentLoaded', function () {
    $$('select[data-default]').forEach(function (sel) { var d = sel.getAttribute('data-default'); if (d) sel.value = d; });
    initHeader();
    initPredictive();
    init(document);
  });

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) {
    init(e.target);
    if (e.target.querySelector('.header')) initHeader();
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.hero__slide');
    var hero = e.target.closest('[data-hero]');
    if (slide && hero && hero._go) {
      clearInterval(hero._timer);
      hero._go($$('.hero__slide', hero).indexOf(slide));
      clearInterval(hero._timer);
    }
  });

  window.VG = VG;
})();

/* FIX v2.1: float the transparent header over the hero only when the hero is the first section */
(function () {
  function setup() {
    var wrap = document.querySelector('.header-wrapper--transparent');
    var sec = wrap && (wrap.closest('.shopify-section') || wrap.parentElement);
    var first = document.querySelector('#MainContent > .shopify-section:first-child');
    var ok = !!(wrap && sec && first && first.querySelector('.hero, .banner'));
    document.body.classList.toggle('header-over-hero', ok);
    if (ok && window.scrollY < 40) document.documentElement.style.setProperty('--vg-header-h', sec.offsetHeight + 'px');
  }
  document.addEventListener('DOMContentLoaded', setup);
  window.addEventListener('load', setup);
  window.addEventListener('resize', setup);
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach(function (ev) {
    document.addEventListener(ev, function () { setTimeout(setup, 60); });
  });
})();
